export module Config {
    export const API_URL = process.env.NODE_ENV === "production" ? "https://rodarapi.azurewebsites.net" : "https://localhost:5001";
    export const ADOBE_DC_CLIENT_ID = "780897e049f24799ab503609f68003f0";
}